// extracted by mini-css-extract-plugin
export var originalPrice = "_wg-0";